import { render, staticRenderFns } from "./AsideCard.vue?vue&type=template&id=61154fbe&scoped=true"
import script from "./AsideCard.vue?vue&type=script&lang=js"
export * from "./AsideCard.vue?vue&type=script&lang=js"
import style0 from "./AsideCard.vue?vue&type=style&index=0&id=61154fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61154fbe",
  null
  
)

export default component.exports